export const VITAMIN_AND_SUPPLEMENT_SLUGS = {
  VITAMIN_B12: 'vitamin-b12-500-mcg',
  VITAMIN_D3: 'vitamin-d3-2000-iu',
  VITAMIN_B6: 'vitamin-b6-50-mg',
  OMEGA_3_FISH_OIL: 'omega-3-fish-oil-1000-mg',
};

export const VITAMINS_AND_SUPPLEMENTS = Object.values(
  VITAMIN_AND_SUPPLEMENT_SLUGS,
);

export const VITAMINS_PROMO_CARD_SLUG = 'vitamins-launch-promo';
